<template>
  <div>
    <a-space>
      <a-button type="primary" @click="addLoadingOrder">{{$t('button.addLoadingOrder')}}</a-button>
      <a-button type="primary" @click="deleteLoadingOrder">{{$t('button.deleteLoadingOrder')}}</a-button>
      <a-button type="primary" @click="issue">{{$t('button.issue')}}</a-button>
      <a-button type="primary" @click="refresh">{{$t('button.query')}}</a-button>
      <a-button type="primary" @click="reset">{{$t('button.reset')}}</a-button>
    </a-space>
    <br/><br/>
    <a-space>
      <vxe-input v-model="query['no']" placeholder="placeholder.loadingOrderNo" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-input v-model="query['dockNo']" placeholder="business.label.dock" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-input v-model="query['vehicleNo']" placeholder="business.label.vehicleNo" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-input v-model="query['driver']" placeholder="business.label.driver" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-input v-model="query['driverPhone']" placeholder="business.label.phone" @clear="refresh" @keydown.native.enter="refresh"/>
      <vxe-date-range-picker v-model="query.range" linked-panels placeholder="business.label.invoiceTime" type="date" @change="refresh"/>
    </a-space>
    <vxe-table ref="table" :data="data" :loading="loading" @cell-dblclick="({row})=>rowDblClick(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="order.no" title="business.label.loadingOrderNo"/>
      <vxe-column field="order.invoiceTime" title="business.label.invoiceTime" width="170"/>
      <vxe-column field="order.operator" title="business.label.maker"/>
      <vxe-column field="order.deliverer" title="business.label.deliver"/>
      <vxe-column field="dock.no" title="business.label.dock"/>
      <vxe-column field="vehicle.no" title="business.label.vehicleNo"/>
      <vxe-column field="order.driver" title="business.label.driver"/>
      <vxe-column field="order.driverPhone" title="business.label.phone"/>
      <vxe-column field="vehicle.type" title="business.label.vehicleType"/>
      <vxe-column field="order.vehicleInPlaceStatus" title="business.label.vehicleInPlaceStatus"/>
      <vxe-column field="order.departureTime" title="business.label.departureTime" width="170"/>
      <vxe-column field="order.notes" title="business.label.notes"/>
    </vxe-table>
    <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" style="height: 24px" @page-change="pageChange"/>
    <loading-order-editor ref="loadingOrderEditor" @success="fetch"/>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import { OPERATOR, WAREHOUSE } from '@/store/mutation-types'
import { findAll, post } from '@/api/Api'
import api from '@/api'
import LoadingOrderEditor from '@/views/delivery/modal/LoadingOrderEditor.vue'

export default {
  components: { LoadingOrderEditor },
  props: {
    queryParam: { type: Object, default: null }
  },
  data() {
    return {
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      data: [],
      loading: false,
      page: 1,
      size: 20,
      contentSize: 0,
      query: {
        'no': '',
        'dockNo': '',
        'vehicleNo': '',
        'driver': '',
        'driverPhone': '',
        orderStatus: 0,
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      },
      orderType: { id: this.queryParam.value.business.orderTypeId }
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = Object.assign({}, this.query)
      if (args.range.length > 0) {
        args['dateFilter'] = { start: args.range[0], end: args.range[1] }
      } else {
        args['dateFilter'] = null
      }
      findAll('loadingOrderFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
          if (this.data.length > 0) {
            this.$refs.table.setRadioRow(this.data[0])
            this.$refs.table.setCurrentRow(this.data[0])
          }
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = {
        'no': '',
        'dockNo': '',
        'vehicleNo': '',
        'driver': '',
        'driverPhone': '',
        orderStatus: 0,
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      }
      this.refresh()
    },
    rowDblClick(row) {
      this.$refs.loadingOrderEditor.open([row])
    },
    addLoadingOrder() {
      this.loading = true
      const args = {
        orderType: this.orderType,
        operator: this.operator.name,
        warehouse: this.warehouse,
        distributionType: 2,
        details: []
      }
      post(api.deliverySave, {}, args).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.fetch()
        }
      }).finally(() => this.loading = false)
    },
    deleteLoadingOrder() {
      const that = this
      this.$confirm({
        title: '是否确认删除装车单:',
        onOk() {
          that.cancelLoadingOrder()
        },
        onCancel() {
        },
        centered: true
      })
    },
    cancelLoadingOrder() {
      this.loading = true
      const deleteData = {
        id: this.$refs.table.getCurrentRecord().order.id
      }
      post(api.deliveryCancelOrder, {}, deleteData).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.deleteSuccess'))
          this.fetch()
        }
      }).finally(() => this.loading = false)
    },
    issue() {
      const currentRow = this.$refs.table.getCurrentRecord()
      if (currentRow === null) {
        return this.$warning({
          title: '请先选择装车单',
          centered: true,
          okText: '确定'
        })
      }
      this.loading = true
      post(api.deliveryIssue, {}, { no: currentRow.order.no }).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.issueSuccess'))
          this.fetch()
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>